const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function track(event, data = {}) {
  try {
    fetch(`${API}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event, data, path: window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
  // GA4 (dataLayer queues events even before gtag loads) + Meta Pixel forwarding
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
    if (typeof window.fbq === 'function') {
      if (event === 'lead_submit') window.fbq('track', 'Lead', data);
      else window.fbq('trackCustom', event, data);
    }
  } catch (_) {}
}

export function utmParams() {
  const p = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const out = {};
  keys.forEach((k) => {
    const v = p.get(k);
    if (v) out[k] = v;
  });
  return out;
}
